export enum ZapierIntegrationStatus {
  notActive = "Not active",
  active = "Active",
  turnedOff = "Turned off",
  notFound = "Integration not found",
  error = "Error"
}
